import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ArticlePage } from './pages/ArticlePage';
import { HomePage } from './pages/HomePage';
import { CategoryPage } from './pages/CategoryPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { ReporterDashboard } from './pages/ReporterDashboard';
import { PredictionPage } from './pages/PredictionPage';
import { BountiesPage } from './pages/BountiesPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { PopupProvider } from './contexts/PopupContext';
import { EmailSignupPopup } from './components/EmailSignupPopup';
import { usePopup } from './contexts/PopupContext';
import { CryptoTicker } from './components/CryptoTicker';
// Add animation keyframes to the global styles
const GlobalStyles = () => {
  return <style jsx global data-id="element-0">{`
      @keyframes slide-up {
        from {
          transform: translateY(100%);
        }
        to {
          transform: translateY(0);
        }
      }
      .animate-slide-up {
        animation: slide-up 0.3s ease-out forwards;
      }
    `}</style>;
};
// Wrapper component to use the popup context
const AppContent = () => {
  const {
    isEmailPopupOpen,
    closeEmailPopup
  } = usePopup();
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
      <GlobalStyles data-id="element-2" />
      <EmailSignupPopup isOpen={isEmailPopupOpen} onClose={closeEmailPopup} data-id="element-3" />
      <Routes data-id="element-4">
        {/* Public Routes */}
        <Route path="/" element={<>
              <Header data-id="element-6" />
              <CryptoTicker data-id="element-7" />
              <HomePage data-id="element-8" />
              <Footer data-id="element-9" />
            </>} data-id="element-5" />
        <Route path="/category/:category" element={<>
              <Header data-id="element-11" />
              <CryptoTicker data-id="element-12" />
              <CategoryPage data-id="element-13" />
              <Footer data-id="element-14" />
            </>} data-id="element-10" />
        <Route path="/article/:id" element={<>
              <Header data-id="element-16" />
              <CryptoTicker data-id="element-17" />
              <ArticlePage data-id="element-18" />
              <Footer data-id="element-19" />
            </>} data-id="element-15" />
        <Route path="/predictions" element={<>
              <Header data-id="element-21" />
              <CryptoTicker data-id="element-22" />
              <PredictionPage data-id="element-23" />
              <Footer data-id="element-24" />
            </>} data-id="element-20" />
        <Route path="/bounties" element={<>
              <Header data-id="element-26" />
              <CryptoTicker data-id="element-27" />
              <BountiesPage data-id="element-28" />
              <Footer data-id="element-29" />
            </>} data-id="element-25" />
        <Route path="/login" element={<LoginPage data-id="element-31" />} data-id="element-30" />
        <Route path="/signup" element={<SignupPage data-id="element-33" />} data-id="element-32" />
        {/* Protected Routes */}
        <Route path="/dashboard/*" element={<ProtectedRoute data-id="element-35">
              <ReporterDashboard data-id="element-36" />
            </ProtectedRoute>} data-id="element-34" />
      </Routes>
    </div>;
};
export function App() {
  return <AuthProvider data-id="element-37">
      <PopupProvider data-id="element-38">
        <BrowserRouter data-id="element-39">
          <AppContent data-id="element-40" />
        </BrowserRouter>
      </PopupProvider>
    </AuthProvider>;
}